export const filterPenthouses = (list: Object[], state) => {
  
 if (!state.filtersActive) return list;

  let views = {
    moscowCity: 'Москва Сити',
    river: 'Долина реки Раменки',
    msu: 'МГУ',
    park: 'Парк 50-ти летия Октября'
  }

  let listFilteredByViews = state.filtersActive.views && state.filtersActive.views.length > 0 ? list.filter((item) => {
    return item.views.find(item => {
      return state.filtersActive.views.find(view => {
        return views[view] === item 
      })
    })
  }) : list;

  let listFilteredByViewsAndTowers = state.filtersActive.towers && state.filtersActive.towers.length > 0 ? listFilteredByViews.filter(item => {
    return state.filtersActive.towers.includes(item.tower)
  }) : listFilteredByViews



  return listFilteredByViewsAndTowers.filter(item => {
    

    let priceOfPenthouse = parseInt(item.priceFull.split(/\s/).join(''))
    let areaOfPenthouse = parseInt(item.area.split(/\s/).join(''))
    let priceMaxInFilter = parseInt(state.filtersActive.priceMax * 1000000)
    let priceMinInFilter = parseInt(state.filtersActive.priceMin * 1000000)
    let areaMaxInFilter = parseInt(state.filtersActive.areaMax)
    let areaMinInFilter = parseInt(state.filtersActive.areaMin)
    // status - продано или нет
    let status = state.statusesAndPrices.content && state.statusesAndPrices.content.find(itemWithStatus => itemWithStatus.pentNumber === item.pentNumber).status

    return priceOfPenthouse < priceMaxInFilter && 
           priceOfPenthouse > priceMinInFilter &&
           areaOfPenthouse < areaMaxInFilter &&
           areaOfPenthouse > areaMinInFilter &&
           status; 
  })
}